import { ArrowRight } from "lucide-react";
import { Reveal, SectionHeader } from "../Reveal";
import { scrollToId } from "../../lib/scroll";

const STEPS = [
    { num: "01", title: "CHOOSE YOUR CAMPAIGN", desc: "Submit your campaign and select your advertising formats, markets, schedule, and number of billboards or screens based on available advertising inventory." },
    { num: "02", title: "PROVIDE YOUR CREATIVE", desc: "Upload your finished advertisement — 7 words or less plus your logo — or add our custom billboard design service." },
    { num: "03", title: "WE REVIEW & APPROVE", desc: "We review your artwork against applicable network requirements. Every advertisement must be approved before it goes live." },
    { num: "04", title: "SCHEDULE YOUR AD", desc: "Your campaign is scheduled into your selected time slots, subject to network inventory, availability, and confirmation." },
    { num: "05", title: "YOUR AD GOES LIVE", desc: "Once artwork is approved and placement availability is confirmed, your campaign launches. Your brand, everywhere." },
];

export const FunnelHow = () => (
    <section id="how" className="relative bg-noir py-24 sm:py-32 overflow-hidden" data-testid="funnel-how">
        <div className="absolute inset-0 led-dots opacity-30" aria-hidden="true" />
        <div className="relative mx-auto max-w-[1200px] px-4 sm:px-6">
            <SectionHeader
                eyebrow="HOW IT WORKS"
                title={<>FIVE STEPS TO <span className="text-hotpink led-text-glow">THE BIG SCREEN.</span></>}
            />
            <div className="mx-auto max-w-3xl">
                {STEPS.map((s, i) => (
                    <Reveal key={s.num} delay={i * 0.05}>
                        <div className={`group flex items-start gap-6 sm:gap-8 py-7 ${i < STEPS.length - 1 ? "border-b border-white/8" : ""}`} data-testid={`how-step-${s.num}`}>
                            <span className="font-display text-4xl sm:text-6xl font-extrabold text-white/10 group-hover:text-hotpink/50 transition-colors duration-500 leading-none">
                                {s.num}
                            </span>
                            <div className="pt-1">
                                <h3 className="font-alt text-sm sm:text-base font-bold tracking-[0.16em] text-white">{s.title}</h3>
                                <p className="mt-2 text-sm leading-relaxed text-zinc-400">{s.desc}</p>
                            </div>
                        </div>
                    </Reveal>
                ))}
            </div>
            <Reveal delay={0.2}>
                <div className="mt-10 text-center">
                    <p className="mx-auto max-w-xl text-xs text-zinc-500" data-testid="how-timing-note">
                        Campaign launch timing depends on artwork approval and confirmed placement availability.
                    </p>
                    <button className="btn-glossy-pink mt-6" onClick={() => scrollToId("#pricing")} data-testid="how-pricing-button">
                        SEE CAMPAIGN OPTIONS <ArrowRight size={15} />
                    </button>
                </div>
            </Reveal>
        </div>
    </section>
);
